let callbacks = [];
let registered = false;

export const onRegisterSearchCriteria = (callback) => {
  if (!registered)
    callbacks.push(callback);
  else
    callback();
};

export const registerSearchCriteria = () => {
  registered = true;
  callbacks.forEach((fn) => fn());
  callbacks = [];
};



// WEBPACK FOOTER //
// ./srp/scripts/utils/on-register-search-criteria.js